<template>
  <div class="component__fff-com-vn">
    <template v-if="!disabled_fff">
      <div style="height:calc(100vh - 126px); overflow-y: scroll;" class="hide--scroll">
        <div>
          <div style="padding:20px  10px 0 0; position: relative; margin-top:10px; background-color:#343a3f; ">
            <component__bar-chart-fff style="height:150px;" :chart-data="chart_data"
                                      ref="component__line-chart"></component__bar-chart-fff>
          </div>
          <div class="text-info" style="margin-top: 5px">
            <p style="font-weight: 700; font-size: 13px">*{{ $t('keyword.chart_message') }}
              &nbsp;</p>
          </div>
        </div>

        <div style="margin: 25px 0 15px 0;">
          <el-row>
            <el-col :sm="17">
              <el-autocomplete id="focus_fff" v-model="base_keyword" :placeholder="$t('keyword.enter_keyword_analysis')"
                               size="small" :fetch-suggestions="m__suggest_keyword" :disabled="loading"
                               style="width: 360px;" @keyup.enter.native="m__enter_input"></el-autocomplete>
              &nbsp;&nbsp;
              <el-select v-if="product_list" size="small" value="" filterable v-model="selected_product"
                         :placeholder="$t('keyword.select_product')">
                <el-option v-for="item in product_list" :key="item.id" :value="item.id" :label="item.name"></el-option>
              </el-select>
              &nbsp;&nbsp;
              <el-button size="small" type="primary" :loading="loading" @click="m__try_get_keyword_result"
                         icon="el-icon-search" style="height: 31px !important;">
                {{ $t('keyword.research_keyword') }}
              </el-button>
            </el-col>
            <el-col :sm="7" class="text-right">
              <strong style="padding-left:5px; font-size: 14px">{{ $t('keyword.total_shopee_volume') }}:</strong>&nbsp;
              <strong class="text-primary" style="padding-left:5px; font-size: 14px">
                {{ (fetch_loading ? '-' : this.result.reduce((t, i) => t + i.sp_volume, 0)) | currency }}
              </strong>
            </el-col>
          </el-row>
        </div>


        <el-row>
          <el-col :sm="12">
            &nbsp;
          </el-col>
          <el-col :sm="12" class="text-right" style="padding-right: 10px;">
            <strong v-if="fetch_loading" class="text-danger" style="font-size: 13px">
              <i class="el-icon-loading"></i> {{ $t('keyword.getting_shopee_data') }}</strong>
            <strong v-if="fetched" class="text-success" style="font-size: 13px">
              <i class="el-icon-check"></i> {{ $t('keyword.updated_shopee_data') }}</strong>
          </el-col>
        </el-row>

        <el-row style="margin-top: 20px">
          <el-col :sm="12">
            <el-pagination :total="c__result_filter.length" :current-page.sync="filter.page_index"
                           :page-size="filter.page_size" @current-change="m__on_paginate_change"
                           layout="prev, pager, next, total"></el-pagination>
          </el-col>
          <el-col :sm="12" class="text-right" style="display: flex; gap: 10px; justify-content: right">
            <el-button size="mini" @click="m__show_filter_dialog" :disabled="!shop.username || fetch_loading">
              <i class="ti-panel"></i>&nbsp; {{ $t('base.filter') }}
              <strong style="font-weight: 600" v-if="filter2.some(i => i.value)" class="text-success">[ ON ]</strong>
              <strong style="font-weight: 700" v-else class="text-danger">[ OFF ]</strong>
            </el-button>
            <div style="width: 400px; display: flex; margin-left: 5px" class="merge-select-input">
              <el-select size="mini" v-model="search_keyword_type" style="width: 150px">
                <el-option :label="$t('base.expanded_search')" value=""></el-option>
                <el-option :label="$t('base.exact_search')" value="exact"></el-option>
              </el-select>
              <el-input v-model="search_keyword" size="mini" :placeholder="$t('input.placeholder')"
                        style="width: 250px"
                        suffix-icon="el-icon-search" class="input" clearable>
              </el-input>
            </div>
          </el-col>
        </el-row>

        <div class="table-responsive">
          <el-table
            :data="c__result__paging" @sort-change="m__sort_change"
            style="width: 100%; margin-top: 10px; overflow-x: scroll">
            <el-table-column
              label="#"
              width="40">
              <template slot-scope="scope">
                <el-checkbox :disabled="c__keyword_text_list.includes(scope.row.keyword)"
                             v-model="scope.row.checked"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('base.keyword')"
              width="250px"
              show-tooltip-when-overflow>
              <template slot-scope="scope">
                <template v-if="scope.row.is_hidden">
                  <a href="/product-pack" target="_blank">{{ scope.row.keyword }}</a>
                </template>
                <template v-else>
                  <span class="atosa-keyword">{{ scope.row.keyword.normalize() }}</span>
                </template>
              </template>
            </el-table-column>
            <el-table-column
              prop="relevance"
              :label="$t('base.relevance')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.relevance === 0 ? '-' : scope.row.relevance }}
              </template>
            </el-table-column>
            <el-table-column
              prop="sp_volume"
              :label="$t('base.shopee_volume')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.sp_volume | currency }}
              </template>
            </el-table-column>
            <el-table-column prop="sp_price" :label="$t('base.recommend_price')" sortable="custom">
              <template slot-scope="scope">
                {{ scope.row.sp_price | currency }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.action')" width="140px">
              <template slot-scope="scope">
                <el-button size="mini" @click="m__remove_keyword_index(scope.row)">{{ $t('base.delete') }}</el-button>
                <el-button size="mini" @click="m__pickup_item(scope.row)"
                           v-if="!c__keyword_text_list.includes(scope.row.keyword)">
                  <span class="ti-arrow-right"></span>
                </el-button>
                <template v-else>
                  <span class="el-icon-success" style="color:greenyellow; font-size:20px; margin-left:10px;"></span>
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-row>
          <el-col :sm="12">
            <el-pagination :total="c__result_filter.length" :current-page.sync="filter.page_index"
                           :page-size="filter.page_size" @current-change="m__on_paginate_change"
                           layout="prev, pager, next, total"></el-pagination>
          </el-col>
        </el-row>
      </div>
    </template>
    <div v-else
         style="color:white; background-color: orangered; font-weight: 600; text-align: center; padding:6px 8px; -webkit-border-radius: 4px;-moz-border-radius: 4px;border-radius: 4px;">
      {{ $t('keyword.can_not_connect_fff')
    </div>

    <el-dialog :visible.sync="show_filter" :close-on-click-modal="false" width="600px">
      <div slot="title" style="padding:10px">
        <form @submit.prevent="m__start_filter">
          <div @keyup.enter.navtive="m__start_filter" tabindex="0">
            <el-table :data="filter2">
              <el-table-column :label="$t('base.column')" prop="label">
                <template slot-scope="scope">
                  <span style="font-weight: 700" :class="scope.row.value ? 'text-success' : ''">{{
                      scope.row.label
                    }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.expression')" prop="expression" width="100px">
                <template slot-scope="scope">
                  <el-select class="full-w" size="mini" v-model="scope.row.expression">
                    <el-option label=">" value=">"></el-option>
                    <el-option label="<" value="<"></el-option>
                    <el-option label="=" value="==="></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.value')" prop="value" width="120px">
                <template slot-scope="scope">
                  <el-input size="mini" v-model="scope.row.value" type="number"></el-input>
                </template>
              </el-table-column>
              <el-table-column :label="$t('base.optional')" width="100px" align="right">
                <template slot-scope="scope">
                  <div style="height: 3px"></div>
                  <el-button size="mini" type="danger"
                             @click="() => {scope.row.value = null; scope.row.expression = '>'}">Reset
                  </el-button>
                  <div style="height: 3px"></div>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <br><br>
          <div class="text-right">
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="m__delete_filter">
              {{ $t('base.delete_filter') }}
            </el-button>
            <el-button size="mini" type="primary" icon="el-icon-check" @submit.prevent="m__start_filter"
                       native-type="submit"> {{ $t('base.execute') }}
            </el-button>
          </div>
        </form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {FFF_COM_VN} from '../../addon/fff'
import Component__lineChartFff from './component__line_chartjs'
import {take as _take, orderBy as _orderBy, uniqBy as _uniqBy} from 'lodash'
import Component__barChartFff from './component__bar_chartjs'
import {SPUserV4} from '../../addon/SPUserV4'
import {google_volume_fixed_list} from '../../addon/fixed_list'
import {fix_ads_mixins} from "../../mixins/fix_ads";
import {global_shops} from "../../addon/global_config";

export default {
  name: 'component__fff-com-vn',

  mixins: [fix_ads_mixins],

  components: {
    Component__barChartFff,
    Component__lineChartFff
  },

  props: {
    shop: {
      type: Object,
      value: {}
    },
    keywords: {
      type: Array,
      default: []
    },
    sp_user: {
      type: Object,
      value: null
    },
    product_list: {
      type: Array,
      default: []
    },
    fff: null
  },

  data() {
    return {
      sort_option: {
        order: null,
        prop: null
      },
      base_keyword: '',
      base_type: 'relevancy',
      current_keyword: '',
      current_type: '',
      loading: false,
      fff_profile: {},
      fff_show: true,
      chart_data: {
        labels: [],
        datasets: []
      },
      filter: {
        page_size: 50,
        page_index: 1
      },
      result: [],
      fetch_index: 0,
      fetch_loading: false,
      fetched: false,
      fetch_keyword: '',
      us: new SPUserV4(),
      product_id: 0,
      search_keyword: '',
      search_keyword_type: '',
      search_volume: null,
      select_top_100: false,
      selected_product: null,
      show_filter: false,
      filter2: [
        {
          label: this.$t('base.volume'),
          key: 'results',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        },
        {
          label: this.$t('base.shopee_volume'),
          key: 'sp_volume',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        },
        {
          label: this.$t('base.shopee_price'),
          key: 'sp_price',
          checked: true,
          expression: '>',
          value: null,
          is_percent: false
        }
      ],
      filter_clone: null,
      google_volume_fixed_list,
      save_and_result_list: [],
      is_destroyed: false
    }
  },

  created() {
    if (this.product_list.length) {
      this.selected_product = this.product_list[0].id
    }
    this.EB.$on('m__export_excel_keyword', this.m__export_excel)
    this.EB.$on('m__add_all', this.m__pickup_multiple_item)
    this.EB.$on('m__delete_all', this.m__delete_multiple_item)
  },

  mounted() {
    this.EB.$on('focus_fff', () => {
      this.$nextTick(() => {
        this.$el.querySelector(`#focus_fff`).focus()
      })
    })

    this.EB.$on('m__select_top_100_keywords', () => {
      this.m__select_top_100_keywords()
    })
    this.EB.$on('m__uncheck_all_keywords', () => {
      this.m__uncheck_all_keywords()
    })

    this.EB.$emit('focus_fff')
  },

  beforeDestroy() {
    this.is_destroyed = true
    this.EB.$off('m__export_excel_keyword', this.m__export_excel)
    this.EB.$off('m__add_all', this.m__pickup_multiple_item)
    this.EB.$off('m__delete_all', this.m__delete_multiple_item)
    this.EB.$off('m__select_top_100_keywords', this.m__select_top_100_keywords)
    this.EB.$off('m__uncheck_all_keywords', this.m__uncheck_all_keywords)
  },

  computed: {
    c__keyword_text_list() {
      return this.keywords.map(e => e.keyword)
    },

    c__result_filter() {
      let result = this.result

      if (this.search_volume) {
        result = result.filter(e => e.results >= this.search_volume)
      }

      if (this.filter_clone) {
        for (const item of this.filter_clone) {
          if (item.value) {
            result = result.filter(i => eval(`${i[item.key]}${item.expression}${item.value}`))
          }
        }
      }

      if (this.sort_option.order) {
        this.sort_option.order === 'ascending' && (result = _orderBy(result, [this.sort_option.prop], ['asc']))
        this.sort_option.order === 'descending' && (result = _orderBy(result, [this.sort_option.prop], ['desc']))
      }

      const keyword = this.remove_unicode(this.search_keyword).trim()
      return !this.search_keyword_type
        ? result.filter(e => this.remove_unicode(JSON.stringify(e)).includes(keyword))
        : keyword ? result.filter(e => this.remove_unicode(e.keyword) === keyword) : result
    },

    c__result__paging() {
      let index = (this.filter.page_index - 1) * this.filter.page_size
      return this.c__result_filter.slice(index, index + this.filter.page_size)
    }
  },

  watch: {
    'shop': function () {
      this.m__make_us_user()
    },

    'base_keyword': function () {
      this.base_keyword = this.base_keyword.normalize()
    }
  },

  methods: {
    async m__suggest_keyword(queryString, cb) {
      if (!queryString) {
        cb([])
        return
      }
      const product_id = this.selected_product || this.product_id
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(queryString, product_id, 0)
      if (hint_keywords && hint_keywords.data) {
        cb(hint_keywords.data.map(i => ({value: i.keyword})))
      } else {
        cb([])
      }
    },

    m__start_filter() {
      let any_change = false
      for (const item of this.filter2) {
        if (item.value) {
          any_change = true
          break
        }
      }
      if (!any_change) {
        this.filter_clone = null
      } else {
        this.filter_clone = JSON.parse(JSON.stringify(this.filter2))
      }
      this.show_filter = false
    },

    m__delete_filter() {
      this.filter2.forEach(i => {
        i.value = null
        i.expression = '>'
      })
      this.filter_clone = null
      this.show_filter = false
    },

    m__show_filter_dialog() {
      this.show_filter = true
    },

    m__select_top_100_keywords() {
      const length = this.c__result_filter.length > 100 ? 100 : this.c__result_filter.length
      for (let i = 0; i < length; i++) {
        this.c__result_filter[i].checked = true
      }
    },

    m__uncheck_all_keywords() {
      this.result.forEach(e => e.checked = false)
    },

    m__show_current_keyword() {
      this.$emit('m__show_current_keyword')
    },

    m__pickup_item(item) {
      let checked_items = this.result.filter(e => e.checked)
      if (checked_items.length > 0) {
        checked_items.forEach(item => {
          item.checked = false
          this.$emit('pick', {
            item,
            move: true
          })
        })
      } else {
        item.checked = false
        this.$emit('pick', {
          item,
          move: true
        })
      }
    },

    async m__export_excel() {
      if (!this.result.length) {
        return
      }

      const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/excel-fff', {
        data: this.result.map(i => {
          return {
            keyword: i.keyword,
            results: i.results,
            minCPC: i.minCPC,
            maxCPC: i.maxCPC,
            sp_volume: i.sp_volume,
            sp_price: i.sp_price
          }
        })
      }, {
        ...this.cf(),
        responseType: 'blob'
      })

      const url = window.URL.createObjectURL(new Blob([response.body]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `keyword-${this.base_keyword}-${this.dayjs().unix()}.xlsx`)
      document.body.appendChild(link)
      link.click()
    },

    m__pickup_multiple_item() {
      let checked_items = this.c__result_filter.filter(e => e.checked)
      if (checked_items.length > 0) {
        checked_items.forEach(item => {
          item.checked = false
          this.$emit('pick', {
            item,
            move: false
          })
        })
      }
    },

    m__delete_multiple_item() {
      let checked_items = this.result.filter(e => e.checked)
      if (checked_items.length > 0) {
        for (const item of checked_items) {
          const index = this.result.findIndex(i => i.keyword === item.keyword)
          if (index >= 0) {
            this.result.splice(index, 1)
          }
        }
      }
    },

    m__remove_keyword_index(keyword) {
      this.result = this.result.filter(i => i.keyword !== keyword.keyword)
    },

    async m__make_us_user() {
      if (typeof this.shop.cookie !== 'undefined') {
        this.us = this.sp_user
      }
    },

    m__get_suggestion_keyword(keyword) {
      return new Promise(resolve => {
        this.$http.get(this.API.marketing_get_suggest.replace('_keyword', keyword), this.cf())
          .then(resp => {
            let data = resp.body.data
            resolve(data.toplevel.CompleteSuggestion.map(e => e.suggestion['@data']))
          })
          .catch(() => {
            resolve([keyword])
          })
      })
    },

    async m__get_sp_keyword_info(keyword) {
      keyword.loading = true
      try {
        const product_id = this.selected_product || this.product_id
        const placement = product_id ? '0' : '3'
        const info = await this.sp_user.marketing_get_keyword_volume(keyword.keyword, product_id, placement)
        if (info !== null && info.search_volume > 0) {
          keyword.relevance = info.relevance === 0 ? 7 : info.relevance
          keyword.sp_volume = info.search_volume
          keyword.sp_price = this.m__calculate(info.recommend_price)
        }
      } catch (e) {
      }
      keyword.loading = false
    },

    async m__on_paginate_change() {
      /*this.fetch_loading = true
      for (let i = this.filter.page_size * (this.filter.page_index - 1); i < this.filter.page_size * this.filter.page_index; i++) {
        await this.m__get_sp_keyword_info(this.result[i])
      }
      this.fetch_loading = false*/
    },

    async m__start_get_sp_keyword() {
      this.fetch_loading = true
      this.fetched = false

      try {
        const resp = await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/save_and_result', {
          mipeeUserId: this.$store.state.userInfo.username,
          keyword: this.base_keyword,
          data: this.result.map(i => i.keyword),
          country: this.sp_user.country
        }, this.cf())
        this.save_and_result_list = resp.body
      } catch (e) {
        console.error(e)
      }

      for (const item of this.save_and_result_list) {
        const found = this.result.find(i => i.keyword === item.keyword)
        if (found) {
          found.relevance = item.relevance
          found.sp_volume = item.volume
          found.sp_price = this.m__calculate(item.recommendPrice)
        }
      }

      for (const item of this.result) {
        if (this.current_keyword !== this.base_keyword || this.current_type !== this.base_type || this.is_destroyed) {
          break
        }

        if (item.is_hidden) continue
        if (+item.sp_volume && +item.sp_price) continue

        await this.sleep(200)
        await this.m__get_sp_keyword_info(item)
      }

      // if (this.$store.state.userInfo.username === 'vuducminhdev077') {
      //   for (const item of this.result) {
      //     if (this.current_keyword !== this.base_keyword || this.current_type !== this.base_type || this.is_destroyed) {
      //       break
      //     }
      //
      //     await this.m__get_sp_keyword_info(item)
      //   }
      // }

      this.loading = false
      this.fetch_loading = false
      this.fetched = true
      this.ntf_s(this.$t('keyword.updated_shopee_data'))

      await this.$http.post(this.API.URL_API_SRV_2 + '/keyword/complete', {
        mipeeUserId: this.$store.state.userInfo.username,
        data: this.result.map(i => ({
          keyword: i.keyword,
          volume: i.sp_volume
        })),
        country: this.sp_user.country
      }, this.cf())

      this.is_destroyed = true
      this.is_destroyed = false
    },

    async m__enter_input() {
      if (!this.loading) {
        await this.m__try_get_keyword_result()
      }
    },

    async m__try_get_keyword_result() {
      if (!this.shop.username) {
        this.ntf_w(this.$t('shop.select_for'))
        return
      }

      if (!this.base_keyword) {
        return
      }

      this.result = []

      this.current_keyword = this.base_keyword
      this.current_type = this.base_type

      this.loading = true

      this.product_id = 0
      let page_one = await this.sp_user.get_product_by_page(1)
      if (page_one.length > 0) {
        this.product_id = page_one[0].id
      } else {
        page_one = await this.sp_user.get_product_by_page(1)
        if (page_one.length > 0) {
          this.product_id = page_one[0].id
        }
      }

      try {
        const product_id = this.selected_product || this.product_id
        const hint_keywords = await this.sp_user.marketing_list_keyword_hint(this.base_keyword, product_id, 0)
        const keyword_list = hint_keywords.data.map(i => i.keyword)
        let result = await this.fff.get_keyword_result(keyword_list, 5000, this.base_keyword)
        this.$emit('search')

        if (!result) {
          this.ntf_w(this.$t('keyword.error_while_get_data'))
        } else if (!result.data || !result.data.keywords || !result.data.keywords.length || result.data.keywords.length < 30) {
          this.ntf_w(this.$t('keyword.result_not_found_message', {x: this.base_keyword}))
          await this.m__handle_missing_keyword(this.base_keyword)

          this.ntf_s(this.$t('keyword.start_getting_shopee_data'))
          await this.m__start_get_sp_keyword()
        } else {
          // TODO: reformat keywords
          for (const item of result.data.keywords) {
            Object.assign(item, {
              checked: false,
              sp_volume: 0,
              sp_price: 0,
              relevance: 0,
              loading: false
            })
          }

          if (result.data.traffic) {
            let traffic_data = result.data.traffic
            this.chart_data = {
              labels: traffic_data.map(e => e.time),
              datasets: [
                {
                  label: this.$t('base.mobile'),
                  data: traffic_data.map(e => Math.round(e.mobileImpression)),
                  point: '2px',
                  type: 'bar',
                  pointBorderWith: 2,
                  borderColor: '#687485',
                  pointHoverBorderColor: '#687485',
                  pointHoverBorderWidth: 4,
                  pointBorderColor: '#fff',
                  pointBackgroundColor: 'white',
                  pointHoverBackgroundColor: 'white',
                  lineTension: 0,
                  lineWidth: 1,
                  showLines: true,

                  backgroundColor: '#1aceab'
                },
                {
                  label: this.$t('base.desktop'),
                  data: traffic_data.map(e => Math.round(e.pcImpression)),
                  point: '2px',
                  type: 'bar',
                  pointBorderWith: 2,
                  borderColor: '#687485',
                  pointHoverBorderColor: '#687485',
                  pointHoverBorderWidth: 4,
                  pointBorderColor: '#fff',
                  pointBackgroundColor: 'white',
                  pointHoverBackgroundColor: 'white',
                  lineTension: 0,
                  lineWidth: 1,
                  showLines: true,
                  backgroundColor: '#e74c3d'
                },
                {
                  label: this.$t('base.total'),
                  data: traffic_data.map(e => e.totalImpression),
                  point: '2px',
                  type: 'line',
                  pointBorderWith: 2,
                  borderColor: '#687485',
                  pointHoverBorderColor: '#687485',
                  pointHoverBorderWidth: 4,
                  pointBorderColor: '#fff',
                  pointBackgroundColor: 'white',
                  pointHoverBackgroundColor: 'white',
                  lineWidth: 1,
                  showLines: true,
                  lineTension: 0.3,
                  backgroundColor: 'transparent'
                }
              ]
            }
            this.$refs['component__line-chart'].repaint(this.chart_data)
          }

          // todo: handle missing base keyword
          let temp = result.data.keywords
          if (!temp.some(i => i.keyword === this.base_keyword)) {
            const base_item = {
              keyword: this.base_keyword,
              results: 0,
              sp_volume: 0,
              sp_price: 0,
              relevance: 0,
              checked: false,
              loading: false
            }
            temp.unshift(base_item)
          }

          // todo: take base keyword to top
          if (temp[0].keyword !== this.base_keyword) {
            const index = temp.findIndex(i => i.keyword === this.base_keyword)
            const temp_base = temp[index]
            temp.splice(index, 1)
            temp.unshift(temp_base)
          }

          // todo: ordering keywords
          const first = temp.shift()
          if (this.base_type === 'search') {
            this.result = _take(_orderBy(temp, ['results'], ['desc']), 500)
          } else {
            this.result = _take(temp, 500)
          }
          this.result.unshift(first)

          // TODO: add more keywords
          // await this.m__handle_relevance(this.base_keyword)
          // await this.m__handle_missing_keyword(this.base_keyword)

          for (const item of this.result) {
            item.keyword = item.keyword.normalize()
          }
          this.result = _uniqBy(this.result, 'keyword')

          this.fetch_index = 0
          this.fetch_keyword = this.base_keyword

          this.ntf_s(this.$t('keyword.start_getting_shopee_data'))
          await this.m__start_get_sp_keyword()
        }
      } catch (e) {
        console.error(e)
        this.ntf_w(this.$t('keyword.error_while_get_data'))
      } finally {
        this.loading = false
      }
    },

    async m__handle_relevance(base_keyword) {

      for (const k of base_keyword.trim().split(' ')) {
        const fff_result = await this.fff.get_keyword_result([k], 1, k)
        if (fff_result.data.keywords && fff_result.data.keywords.length) {
          this.result.push({
            ...fff_result.data.keywords[0],
            sp_volume: 0,
            sp_price: 0,
            relevance: 0,
            checked: false,
            loading: false
          })
        }
      }

      const product_id = this.selected_product || this.product_id
      const extend_resp = await this.sp_user.marketing_suggest_keywords(base_keyword, product_id)
      if (extend_resp && extend_resp.data) {
        extend_resp.data = extend_resp.data.filter(i => i.keyword !== base_keyword)

        let index_splice = 1
        for (const item of extend_resp.data) {
          if (this.contain_at_least(base_keyword, item.keyword)) {
            const keyword = {
              keyword: item.keyword,
              results: 0,
              sp_volume: item.search_volume,
              sp_price: item.recommend_price,
              relevance: item.relevance,
              checked: false,
              loading: false
            }
            this.result.splice(index_splice++, 0, keyword)
          }
        }
      }
    },

    async m__handle_missing_keyword(base_keyword) {
      const product_id = this.selected_product || this.product_id
      const hint_keywords = await this.sp_user.marketing_list_keyword_hint(base_keyword, product_id, 0)
      if (hint_keywords && hint_keywords.data) {
        let index_splice = 2
        for (const hint of hint_keywords.data) {
          const extend_resp = await this.sp_user.marketing_suggest_keywords(hint.keyword, product_id)
          if (extend_resp && extend_resp.data) {
            for (const item of extend_resp.data) {
              if (!this.contain_at_least(base_keyword, item.keyword)) continue

              const keyword = {
                keyword: item.keyword,
                results: 0,
                sp_volume: item.search_volume,
                sp_price: item.recommend_price,
                relevance: item.relevance,
                checked: false,
                loading: false
              }
              if (!this.result.some(i => i.keyword.normalize() === item.keyword.normalize())) {
                this.result.splice(index_splice++, 0, keyword)
              }
            }
          }
        }
      } else {
        const extend_resp = await this.sp_user.marketing_suggest_keywords(base_keyword, product_id)
        if (extend_resp && extend_resp.data) {
          let index_splice = 2
          for (const item of extend_resp.data) {
            if (!this.contain_at_least(base_keyword, item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              results: 0,
              sp_volume: item.search_volume,
              sp_price: item.recommend_price,
              relevance: item.relevance,
              checked: false,
              loading: false
            }
            if (!this.result.some(i => i.keyword.normalize() === item.keyword.normalize())) {
              this.result.splice(index_splice++, 0, keyword)
            }
          }
        }
      }

      if (this.result.some(i => i.keyword === base_keyword) && this.result[0].keyword !== base_keyword) {
        const index = this.result.findIndex(i => i.keyword === base_keyword)
        const temp = this.result[index]
        this.result.splice(index, 1)
        this.result.unshift(temp)
      }

      if (!this.result.some(i => i.keyword === base_keyword)) {
        const response = await this.sp_user.marketing_suggest_keywords(b.ase_keyword, product_id)
        if (response && response.data) {
          for (const item of response.data.reverse()) {
            if (!this.contain_at_least(base_keyword, item.keyword, false)) continue
            if (this.result.some(i => i.keyword === item.keyword)) continue

            const keyword = {
              keyword: item.keyword,
              results: 0,
              sp_volume: item.search_volume,
              sp_price: item.recommend_price,
              relevance: item.relevance,
              checked: false,
              loading: false
            }
            this.result.unshift(keyword)
          }
        }
      }
    },

    m__sort_change({
                     prop,
                     order
                   }) {
      this.sort_option.order = order
      this.sort_option.prop = prop
    }
  }
}
</script>

<style lang="scss">
.component__fff-com-vn {
  /*padding: 10px;*/

  .fff-user__profile {
    position: fixed;
    right: 10px;
    bottom: 10px;
    background-color: whitesmoke;
    border-radius: 4px;
    /*box-shadow: 1px 3px 5px rgba(45, 45, 48, .2);*/
    padding: 2px 5px;
  }

  .fff-result {
    th {
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/keyword/component__fff.vue